// extracted by mini-css-extract-plugin
export default {"service-about-text":"ServiceAboutText_service-about-text__XUOcT","theme-grayscale":"ServiceAboutText_theme-grayscale__LwKfj"};